module.exports = __webpack_public_path__ + "static/samgi-logo-1-e82fa63132cec5aa1ce4e0984e185de9.png";